import MyInvestorAccount from "@/views/account/MyInvestorAccount";
import MyInvestorAccountDetails from "@/views/account/MyInvestorAccountDetails";

import CreateAccount from "@/views/account/CreateAccount";
import CreateDemoAccount from "@/views/account/CreateDemoAccount";
import CreateInvestorAccount from "@/views/account/CreateInvestorAccount";
import CreateInvestorAccountDetails from "@/views/account/CreateInvestorAccountDetails";
import CreateInvestorAccountSuccess from "@/views/account/CreateInvestorAccountSuccess";
import CreateLiveAccount from "@/views/account/CreateLiveAccount";
import CreateManagerAccount from "@/views/account/CreateManagerAccount";
import DemoAccount from "@/views/account/DemoAccount";
import DemoAccountDetails from "@/views/account/DemoAccountDetails";
import LiveAccount from "@/views/account/LiveAccount";
import LiveAccountDetails from "@/views/account/LiveAccountDetails";
import ManageInvestorsAccount from "@/views/account/ManageInvestorsAccount";
import ManageInvestorsAccountDetails from "@/views/account/ManageInvestorsAccountDetails";


export default {
  MyInvestorAccount,
  MyInvestorAccountDetails,
  CreateAccount,
  CreateDemoAccount,
  CreateInvestorAccount,
  CreateInvestorAccountDetails,
  CreateInvestorAccountSuccess,
  CreateLiveAccount,
  CreateManagerAccount,
  DemoAccount,
  DemoAccountDetails,
  LiveAccount,
  LiveAccountDetails,
  ManageInvestorsAccount,
  ManageInvestorsAccountDetails,
  
};
